const MAX_FILE_SIZE = 1e6;

function hasExtensionBool(fileName, validExtensions) {
  /*
  regex builds an OR expression from the available extensions with escape characters
  Example: ['.jpg', '.png'] ==> /(\.jpg|\.png)$/
  */
  const regex = new RegExp('(' + validExtensions.join('|').replace(/\./g, '\\.') + ')$');
  return regex.test(fileName);
}

async function checkFileBool(fileBlob, validExtensions) {
  if (fileBlob.size > MAX_FILE_SIZE) return false;
  return hasExtensionBool(fileBlob.name, validExtensions);
}

export { checkFileBool };
